export const MEMBERSHIP_ACTIVE_RATIFICATION_PARAM =
  '?ratificationCode=MembershipIsActiveOrExpired';
